<template>
    <div class="widget-wrapper">
        <div class="metrics">
            <div class="widget-metric">
                <h3>{{ widgets.YTDProspects }}</h3>
                <h4>YTD Prospects</h4>
            </div>
            <div class="widget-metric">
                <h3>{{ widgets.YTDSold }}</h3>
                <h4>YTD Sold</h4>
            </div>
            <div class="widget-metric">
                <h3>{{ widgets.YTDClosePercent }}%</h3>
                <h4>YTD Close %</h4>
            </div>
            <div class="widget-metric">
                <h3>{{ widgets.YTDDeadProspects }}</h3>
                <h4>YTD Dead Prospects</h4>
            </div>
            <div class="widget-metric">
                <h3>{{ widgets.YTDProposals }}</h3>
                <h4>YTD Proposals</h4>
            </div>
            <div class="widget-metric">
                <h3>{{ widgets.YTDAssets }}</h3>
                <h4>AVG Assets</h4>
            </div>
            <div class="widget-metric">
                <h3>{{ widgets.YTDLOIPercent }}%</h3>
                <h4>YTD LOI %</h4>
            </div>
        </div>
        <br>
        <br>
        <div class="charts">
            <div class="widget widget-chart-svg">
                <h3 class="title">Proposal by Providers {{new Date().getUTCFullYear()}}</h3>
                <svg v-if="charts.ProposalByProvider.length > 0" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" :viewBox="chart1ViewBox">
                    <text
                        class="label"
                        v-for="(value, index) of charts.ProposalByProvider"
                        :key="'label' + index"
                        x="60"
                        :y="1 + labelOffsetY1(index) + 8"
                        text-anchor="end">
                        {{ charts.ProposalByProvider[index].name }}
                    </text>  
                    <line
                        v-for="(value, index) in charts.ProposalByProvider.length + 1"
                        :key="'line-' + index"
                        x1="50" :y1="labelLineOffsetY1(index)"
                        x2="65" :y2="labelLineOffsetY1(index)">
                    </line>
                    <line x1="65" y1="0" x2="65" :y2="verticalLineHeightChart1"></line>
                    <rect
                        v-for="(value, index) of charts.ProposalByProvider"
                        :key="'rect-' + index"
                        x="74"
                        :y="labelLineOffsetY1(index) + 3"
                        :width="barWith('propByProviders', value.count, 230)"
                        :height="(100 / charts.ProposalByProvider.length) + 8"
                        rx="3">
                    </rect>
                    <text
                        class="value"
                        v-for="(value, index) of charts.ProposalByProvider"
                        :key="index"
                        x="80"
                        :y="labelOffsetY1(index) + 8"
                        text-anchor="start">
                        {{ charts.ProposalByProvider[index].count }}
                    </text>  
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" :viewBox="chart1ViewBox">
                    <text x="-13">There is no data to be displayed</text>
                </svg>
            </div>
            <div class="widget widget-chart-svg">
                <h3 class="title">Percent of Level of Involvement</h3>
                <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" viewBox="0 10 300 160">
                    <text
                        class="label"
                        v-for="(value, index) of charts.PercentOfLOI"
                        :key="'label' + index"
                        x="60"
                        :y="1 + labelOffsetY2(index) + 6"
                        text-anchor="end">
                        {{ charts.PercentOfLOI[index].name }}
                    </text>
                    <line
                        v-for="(value, index) in charts.PercentOfLOI.length + 1"
                        :key="'line-' + index"
                        x1="50" :y1="labelLineOffsetY2(index) + 5"
                        x2="65" :y2="labelLineOffsetY2(index) + 5">
                    </line>
                    <line x1="65" y1="30" x2="65" :y2="verticalLineHeight"></line>
                    <rect
                        v-for="(value, index) of charts.PercentOfLOI"
                        :key="'rect-' + index"
                        x="74"
                        :y="labelLineOffsetY2(index) + 9"
                        :width="barWith('percentOfLOI', value.count, 230)"
                        :height="(100 / charts.PercentOfLOI.length) - 5"
                        rx="3">
                    </rect>
                    <text
                        class="value"
                        v-for="(value, index) of charts.PercentOfLOI"
                        :key="index"
                        x="80"
                        :y="1 + labelOffsetY2(index) + 6"
                        text-anchor="start">
                        {{ Math.round(((charts.PercentOfLOI[index].count * 100) / percentOfLOISumCount) * 100) / 100 }} %
                    </text>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        data: () => ({
            // chart1ViewBox: '-50 -10 300 200'
        }),

        created() {
        },

        computed: {
            
            ...mapGetters({
                widgets: 'widgets',
                charts: 'charts',
            }),

            verticalLineHeightChart1() {
                let listLen = this.charts.ProposalByProvider.length;
                let finalheight = this.charts.ProposalByProvider.length * 48
                finalheight = listLen === 1  ? this.charts.ProposalByProvider.length * 115 : finalheight;
                finalheight = listLen === 2  ? this.charts.ProposalByProvider.length * 65 : finalheight;
                finalheight = listLen === 3  ? this.charts.ProposalByProvider.length * 48 : finalheight;
                finalheight = listLen === 4  ? this.charts.ProposalByProvider.length * 40 : finalheight;
                finalheight = listLen === 5  ? this.charts.ProposalByProvider.length * 35 : finalheight;
                finalheight = listLen === 6  ? this.charts.ProposalByProvider.length * 32 : finalheight;
                finalheight = listLen === 7  ? this.charts.ProposalByProvider.length * 29 : finalheight;
                finalheight = listLen === 8  ? this.charts.ProposalByProvider.length * 28 : finalheight;
                finalheight = listLen === 9  ? this.charts.ProposalByProvider.length * 26 : finalheight;
                finalheight = listLen === 10 ? this.charts.ProposalByProvider.length * 25 : finalheight;
                finalheight = listLen === 11 ? this.charts.ProposalByProvider.length * 24 : finalheight;
                finalheight = listLen === 12 ? this.charts.ProposalByProvider.length * 23 : finalheight;
                finalheight = listLen === 13 ? this.charts.ProposalByProvider.length * 23 : finalheight;
                finalheight = listLen === 14 ? this.charts.ProposalByProvider.length * 22 : finalheight;
                finalheight = listLen === 15 ? this.charts.ProposalByProvider.length * 22 : finalheight;
                finalheight = listLen > 15   ? this.charts.ProposalByProvider.length * 26 : finalheight;
                return finalheight;
            },

            verticalLineHeight() {
                return this.charts.PercentOfLOI.length * 37.5;
            },

            percentOfLOISumCount() {
                return this.charts.PercentOfLOISumCount == 0 ? 1 : parseInt(this.charts.PercentOfLOISumCount)
            },

            chart1ViewBox() {
                let listLen = this.charts.ProposalByProvider.length;
                let viewBox =  '-50 -10 300 160';
                viewBox = listLen === 3  ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 55):   viewBox;
                viewBox = listLen === 4  ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 45):   viewBox;
                viewBox = listLen === 5  ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 39):   viewBox;
                viewBox = listLen === 6  ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 35):   viewBox;
                viewBox = listLen === 7  ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 32):   viewBox;
                viewBox = listLen === 8  ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 30):   viewBox;
                viewBox = listLen === 9  ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 28):   viewBox;
                viewBox = listLen === 10 ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 27):   viewBox;
                viewBox = listLen === 11 ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 26):   viewBox;
                viewBox = listLen === 12 ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 24.5): viewBox;
                viewBox = listLen === 13 ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 24.5): viewBox;
                viewBox = listLen === 14 ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 23):   viewBox;
                viewBox = listLen === 15 ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 23):   viewBox;
                viewBox = listLen > 15   ? '-50 -10 300 ' + (this.charts.ProposalByProvider.length * 26):   viewBox;
                return viewBox;
            }

        },

        methods: {

            labelOffsetY1 (index) {
                // chart is 100 unit height
                // we divide 100 by the number of items and multiply by index to get offset
                const offset = Math.round(100 / this.charts.ProposalByProvider.length)
                return offset / 2 + (offset + 15) * index
            },

            labelOffsetY2 (index) {
                // chart is 100 unit height
                // we divide 100 by the number of items and multiply by index to get offset
                const offset = Math.round(100 / this.charts.PercentOfLOI.length)
                return offset / 2 + offset + 30 * index
            },

            labelLineOffsetY1 (index) {
                // chart is 100 unit height
                // we divide 100 by the number of items and multiply by index to get offset
                const offset = Math.round(100 / this.charts.ProposalByProvider.length)
                return (offset + 15) * index
            },

            labelLineOffsetY2 (index) {
                // chart is 100 unit height
                // we divide 100 by the number of items and multiply by index to get offset
                const offset = Math.round(100 / this.charts.PercentOfLOI.length)
                return offset + 30 * index
            },
            
            barWith (chart, value, fullWidth) {
                let maxnum = 10000
                if (chart === 'propByProviders') {
                    maxnum = this.charts.ProposalByProviderMaxInArray * 1.35;
                }  else if (chart === 'percentOfLOI'){
                    maxnum = this.charts.PercentOfLOIMaxInArray * 1.10;
                }
                const ratio = value / maxnum;
                return ratio * fullWidth
            }

        }
    }
    
</script>

<style lang="scss" scoped>

    .widget-wrapper {
        padding-bottom: 10px;

        .custom-divider {
            border: 5px solid;
            border-color: black;
        }

         .metrics {
            display: flex;
            flex-wrap: wrap;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;

            .widget-metric {            
                width: auto;
                -ms-flex-pack: center;
                -ms-flex-align: center;
                text-align: center;
                -ms-flex-preferred-size: auto;
                flex-basis: auto;
                margin: 10px 1% 0 1%;
                width: 23%;
                min-height: 75px;
                background: #303030f0; //#303030;
                box-shadow: 0 4px 8px 0 rgb(0 0 0 / 65%);
                transition: 0.3s;
                border-radius: 10px;
                padding: 15px;
                margin-bottom: 15px;
                border-bottom: 1.8px solid black;
                border: 1px solid #c0c7c9;
    
                h3 {
                    margin: auto 0 2px 0;
                    font-size: 2rem;
                    -ms-flex-preferred-size: 100%;
                    flex-basis: 100%;
                    color: #d6daf5;
                    overflow-wrap: break-word;
                }
    
                h4 {
                    color: #a1a3a5;
                    margin: 2px 0 auto 0;
                    padding-bottom: 10px;
                    -ms-flex-preferred-size: 100%;
                    flex-basis: 100%;
                    font-variant: small-caps;
                    font-size: 1rem;
                }
            }

            .widget-metric:hover {
                box-shadow: 0 8px 16px 0 rgb(48 48 48);
            }
        }
    
        .charts {
    
            display: flex;
            flex-wrap: wrap;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;
    
            div.widget.widget-chart-svg {
                // background: #303030;
                background: #303030f0; //#303030;
                margin: 10px 1% 0 1%;
                width: 48%;
                font-size: 1rem;
                overflow: hidden;
                box-shadow: 0 4px 8px 0 rgb(0 0 0 / 65%);
                transition: 0.3s;
                border-radius: 10px;
                margin-bottom: 15px;
                border-bottom: 1.8px solid black;
                border: 1px solid #c0c7c9;
        
                svg {
                    margin: 2px 5px 5px;
                    font-size: .65rem; 
                    overflow: hidden;
        
                    text {
                        dominant-baseline: middle;
                        fill: #a1a3a5;
                        &.value {
                            fill: #ced0de;
                            font-weight: 500;
                        }
                    }
                    
                    line {
                        stroke: #6b74b9;
                        stroke-width: 1;
                    }
        
                    rect {
                        stroke-width: 0;
                        fill: #7d88de;
                    }
                }
        
                .title {
                    color: #ece4e4;
                    margin: 20px 5px 0;
                    text-align: center;
                    font-size: 1.35rem !important;
                }
            }

            div.widget.widget-chart-svg:hover {
                box-shadow: 0 8px 16px 0 rgb(48 48 48);
            }
        }
    }

</style>